/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Quick_Workout_Load_HistoryInputs */

const en_us2_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · from your history`)
};

const pt_br2_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · do seu histórico`)
};

const es_419_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · de tu historial`)
};

const pt_pt2_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · do teu histórico`)
};

const fr_fr2_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · d'après ton historique`)
};

const de_de2_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · aus deinem Verlauf`)
};

const it_it2_quick_workout_load_history = /** @type {(inputs: Quick_Workout_Load_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} · dal tuo storico`)
};

/**
* | output |
* | --- |
* | "{loadText} · from your history" |
*
* @param {Quick_Workout_Load_HistoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_load_history = /** @type {((inputs: Quick_Workout_Load_HistoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Load_HistoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_load_history(inputs)
	if (locale === "es-419") return es_419_quick_workout_load_history(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_load_history(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_load_history(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_load_history(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_load_history(inputs)
	return en_us2_quick_workout_load_history(inputs)
});
export { quick_workout_load_history as "quick-workout.load_history" }